import React, { useEffect, useState } from "react";
import logo1 from "../../assets/images/logo/logo-white.png";
import logo2 from "../../assets/images/logo/logout.svg";
import profileimg from "../../assets/images/profile-image.png";
import questionimg from "../../assets/images/question.svg";
import gridimg from "../../assets/images/grid.svg";
import bellimg from "../../assets/images/notifi-bell.png";
import menu from "../../assets/images/logo/list.svg";
import listmenu from "../../assets/images/logo/Xbox-Menu.svg";
import savefile from "../../assets/images/logo/Check-File.svg";
import moreproducts from "../../assets/images/logo/View-More.svg";
import reqserviceisr from "../../assets/images/logo/Request-Service.svg";
import reqserviceimr from "../../assets/images/logo/Service.svg";
import newfile from "../../assets/images/logo/Plus.svg";
import listview from "../../assets/images/logo/Tasklist.svg";
import about from "../../assets/images/logo/People.svg";
import { FiChevronDown } from "react-icons/fi";
import downArrow from "../../assets/images/downArrow.svg";
import arrowUp from "../../assets/images/arrowUp.svg";
import Modal from "react-modal";

import { Link, Navigate, useNavigate } from "react-router-dom";
import "../../index.css";
import secureLocalStorage from "react-secure-storage";
import Routes from "./data/remote/Routes";
import { ToastContainer, toast } from "react-toastify";
import { Puff } from "react-loader-spinner";

const notify = (message, type) => {
  // alert('error', +message)
  type == "success"
    ? toast.success(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        closeButton: false,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",
      })
    : toast.error(message, {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: false,
        closeButton: false,
        pauseOnHover: false,
        draggable: true,
        progress: undefined,
        theme: "colored",

        style: {
          backgroundColor: "#D92533",
        },
      });
};

const Header = (props) => {
  // useEffect(() => {
  //   console.log(props)
  // }, [])

  const [showDropdown, setShowDropdown] = useState(false);
  const [showDropdown2, setShowDropdown2] = useState(false);
  const [isOpen, setIsOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [image, setImage] = useState("");
  const [email, setEmail] = useState("");
  const [modalIsOpen, setIsOpen4] = useState(false);
  const [modalIsOpen5, setIsOpen5] = useState(false);

  let subtitle;

  function openModal() {
    setIsOpen4(true);
  }
  function afterOpenModal() {
    subtitle.style.color = "#f00";
  }
  function closeModal() {
    setIsOpen4(false);
  }

  function openModal5() {
    setIsOpen5(true);
  }
  function closeModal5() {
    setIsOpen5(false);
  }

  const customStyles = {
    content: {
      top: "50%",
      left: "50%",
      right: "auto",
      bottom: "auto",
      marginRight: "-50%",
      transform: "translate(-50%, -50%)",
      borderRadius: "15px",
    },
  };

  useEffect(() => {
    const f_name = secureLocalStorage.getItem("first_name");
    const l_name = secureLocalStorage.getItem("last_name");
    const user_email = secureLocalStorage.getItem("email");
    const img = secureLocalStorage.getItem("image");

    setFirstName(f_name);
    setLastName(l_name);
    setEmail(user_email);

    if (props.showImage) {
    } else {
      setImage(img);
    }
  }, []);
  useEffect(() => {
    if (props.imageShow) {
      setImage(props.imageShow);
    }
  }, [props.imageShow]);

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };
  const history = useNavigate();

  const handleDropdownToggle = () => {
    setShowDropdown(!showDropdown);
  };
  const handleNotification = () => {
    setShowDropdown2(!showDropdown2);
  };
  function hideOffcanvasHandler() {
    const offcanvasEl = document.querySelector("#myOffcanvas");
    offcanvasEl.style.padding = "0";
  }
  const accessToken = secureLocalStorage.getItem("token");

  const handleLogout = () => {
    // handle logout logic here
    secureLocalStorage.removeItem("email");
    secureLocalStorage.removeItem("token");
    secureLocalStorage.removeItem("first_name");
    secureLocalStorage.removeItem("id");
    secureLocalStorage.removeItem("image");
    secureLocalStorage.removeItem("contact_number");
    secureLocalStorage.removeItem("employment_number");
    secureLocalStorage.removeItem("userLevel");
    history("/");
    notify("Logout successful", "success");
    setLoading(true);

    // var myHeaders = new Headers();
    // myHeaders.append("Authorization", "Bearer " + accessToken);

    // var formdata = new FormData();

    // var requestOptions = {
    //   method: 'POST',
    //   headers: myHeaders,
    //   body: formdata,
    //   redirect: 'follow'
    // };

    // fetch("https://alhikmahinternational.org/al-asab/public/api/logout", requestOptions)
    //   .then(response => response.json())
    //   .then(result => {
    //     if (result.status == true) {
    //       history("/");

    //       secureLocalStorage.removeItem('token')
    //       secureLocalStorage.removeItem('email')
    //       secureLocalStorage.removeItem('first_name')
    //       secureLocalStorage.removeItem('last_name')
    //       notify(result.message, "success");
    //       setLoading(false);

    //     } else {
    //       notify(result.message, "error");
    //       setLoading(false);

    //     }
    //   })
    //   .catch(error => {
    //     console.log('error', error)
    //     setLoading(false);
    //   });
  };

  // const email = secureLocalStorage.getItem('email')

  return (
    <div className="container-fluid headerMainDiv">
      <ToastContainer />
      {loading && (
        <div className="loaderScreen">
          <Puff
            height={80}
            width={120}
            color="rgba(0, 120, 207, 1)"
            ariaLabel="puff-loading"
            wrapperStyle={{}}
            wrapperClassName=""
            visible={true}
          />
        </div>
      )}
      <div className=" headerMain  bd-highlight ">
        <div className="d-flex">
          {email === "approval@gmail.com" ? (
            <div className="p-2 mt-2 bd-highlight">
              <a
                className=""
                data-bs-toggle="offcanvas"
                href="#offcanvasExample"
                role="button"
                aria-controls="offcanvasExample"
              >
                <img src={menu} className="img-nav" alt="..." />
              </a>

              {/* Sidebar */}

              <div
                className="offcanvas offcanvas-start "
                style={{ padding: 0 }}
                tabIndex="-1"
                id="offcanvasExample"
                aria-labelledby="offcanvasExampleLabel"
              >
                <div className="offcanvas-header">
                  <Link to={"/home"}>
                    <h5 className="offcanvas-title" id="offcanvasExampleLabel">
                      <img src={logo1} className="img-nav" alt="..." />
                      AL-Asab
                    </h5>
                  </Link>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="list-group list-group-flush ">
                  <nav className="sidebar py-2 mb-4">
                    <ul
                      className="dropdown-list nav flex-column"
                      id="nav_accordion"
                    >
                      <li
                        className="nav-item"
                        aria-label="Close"
                        data-bs-dismiss="offcanvas"
                      >
                        <Link
                          to={"/recent"}
                          className="sidebar-items sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                        >
                          <img src={listmenu} className="side-nav" alt="..." />
                          <sub>Recent </sub>
                        </Link>
                      </li>

                      <li
                        className="nav-item"
                        aria-label="Close"
                        data-bs-dismiss="offcanvas"
                      >
                        <Link
                          to={"/saved"}
                          className="sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                        >
                          <img src={savefile} className="side-nav" alt="..." />
                          <sub>Save </sub>
                        </Link>
                      </li>
                      <li
                        className="nav-item"
                        aria-label="Close"
                        data-bs-dismiss="offcanvas"
                      >
                        <Link
                          to={"/more-products"}
                          className="sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                        >
                          <img
                            src={moreproducts}
                            className="side-nav"
                            alt="..."
                          />

                          <sub>More Products </sub>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          onClick={() => handleToggle()}
                          to={"#"}
                          className="sidebar-items list-group-item list-group-item-action list-group-item-light p-3 "
                          data-bs-toggle="collapse"
                          data-bs-target="#menu_item1"
                        >
                          <img
                            src={reqserviceisr}
                            className="side-nav "
                            alt="..."
                          />
                          <sub>IMR/ISR</sub>
                          {!isOpen ? (
                            <div>
                              <img className="headerDropdown" src={downArrow} />
                            </div>
                          ) : (
                            <div>
                              <img className="headerDropdown" src={arrowUp} />
                            </div>
                          )}
                        </Link>
                        <ul
                          id="menu_item1"
                          className={`submenu collapse ${isOpen ? "show" : ""}`}
                          data-bs-parent="#nav_accordion"
                        >
                          <li aria-label="Close" data-bs-dismiss="offcanvas">
                            <Link
                              to={"/imrisr-approval"}
                              className="sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                            >
                              <img
                                src={listview}
                                className="side-nav"
                                alt="..."
                              />

                              <sub className="iSRiMRListView">
                                Create IMR/ISR Requests{" "}
                              </sub>
                            </Link>
                          </li>

                          <li aria-label="Close" data-bs-dismiss="offcanvas">
                            <Link
                              to={"/imrlist-approval"}
                              className="sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                            >
                              <img
                                src={listview}
                                className="side-nav"
                                alt="..."
                              />
                              <sub className="iSRiMRListView">
                                View IMR/ISR Requests{" "}
                              </sub>
                            </Link>
                          </li>
                        </ul>
                      </li>
                      {/* 
                      <li className="nav-item">
                        <Link
                          to={"/about-us"}
                          className="sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                        >
                          <img src={about} className="side-nav" alt="..." />
                          <sub>About Us{" "}</sub>
                        </Link>
                      </li> */}
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          ) : (
            <div className="p-2 mt-2 bd-highlight">
              <a
                className=""
                data-bs-toggle="offcanvas"
                href="#offcanvasExample"
                role="button"
                aria-controls="offcanvasExample"
              >
                <img src={menu} className="img-nav" alt="..." />
              </a>

              {/* Sidebar */}

              <div
                className="offcanvas offcanvas-start "
                style={{ padding: 0 }}
                tabIndex="-1"
                id="offcanvasExample"
                aria-labelledby="offcanvasExampleLabel"
              >
                <div className="offcanvas-header">
                  <Link to={"/home"}>
                    <h5 className="offcanvas-title" id="offcanvasExampleLabel">
                      <img src={logo1} className="img-nav" alt="..." />
                      AL-Asab
                    </h5>
                  </Link>
                  <button
                    onClick={() => setIsOpen(false)}
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="offcanvas"
                    aria-label="Close"
                  ></button>
                </div>
                <div className="list-group list-group-flush ">
                  <nav className="sidebar py-2 mb-4">
                    <ul
                      className="dropdown-list nav flex-column"
                      id="nav_accordion"
                    >
                      <li
                        className="nav-item"
                        aria-label="Close"
                        data-bs-dismiss="offcanvas"
                      >
                        <Link
                          to={"/recent"}
                          className="sidebar-items sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                        >
                          <img src={listmenu} className="side-nav" alt="..." />
                          <sub>Recent </sub>
                        </Link>
                      </li>

                      <li
                        className="nav-item"
                        aria-label="Close"
                        data-bs-dismiss="offcanvas"
                      >
                        <Link
                          to={"/saved"}
                          className="sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                        >
                          <img src={savefile} className="side-nav" alt="..." />
                          <sub>Saved </sub>
                        </Link>
                      </li>
                      <li
                        className="nav-item"
                        aria-label="Close"
                        data-bs-dismiss="offcanvas"
                      >
                        <Link
                          // to={"/more-products"}
                          className="sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                        >
                          <img
                            src={moreproducts}
                            className="side-nav"
                            alt="..."
                          />

                          <sub>More Products </sub>
                        </Link>
                      </li>
                      <li className="nav-item">
                        <Link
                          onClick={() => handleToggle()}
                          to={"#"}
                          className="sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                          data-bs-toggle="collapse"
                          data-bs-target="#menu_item1"
                        >
                          <img
                            src={reqserviceisr}
                            className="side-nav"
                            alt="..."
                          />
                          <sub>IMR/ISR</sub>
                          {!isOpen ? (
                            <div>
                              <img className="headerDropdown" src={downArrow} />
                            </div>
                          ) : (
                            <div>
                              <img className="headerDropdown" src={arrowUp} />
                            </div>
                          )}
                        </Link>
                        <ul
                          id="menu_item1"
                          className={`submenu collapse ${isOpen ? "show" : ""}`}
                          data-bs-parent="#nav_accordion"
                        >
                          <li aria-label="Close" data-bs-dismiss="offcanvas">
                            <Link
                              to={"/createimr"}
                              className="sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                            >
                              <img
                                src={listview}
                                className="side-nav"
                                alt="..."
                              />

                              <sub className="iSRiMRListView">Create IMR </sub>
                            </Link>
                          </li>
                          <li aria-label="Close" data-bs-dismiss="offcanvas">
                            <Link
                              to={"/createisr"}
                              className="sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                            >
                              <img
                                src={listview}
                                className="side-nav"
                                alt="..."
                              />

                              <sub className="iSRiMRListView">Create ISR </sub>
                            </Link>
                          </li>
                          <li aria-label="Close" data-bs-dismiss="offcanvas">
                            <Link
                              to={"/imr-list"}
                              className="sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                            >
                              <img
                                src={listview}
                                className="side-nav"
                                alt="..."
                              />
                              <sub className="iSRiMRListView">
                                View IMR/ISR{" "}
                              </sub>
                            </Link>
                          </li>
                        </ul>
                      </li>
                      {/* <li className="nav-item">
                        <Link
                          to={"/about-us"}
                          className="sidebar-items list-group-item list-group-item-action list-group-item-light p-3"
                        >
                          <img src={about} className="side-nav" alt="..." />
                          <sub>About Us{" "}</sub>
                        </Link>
                      </li> */}
                    </ul>
                  </nav>
                </div>
              </div>
            </div>
          )}

          <div className="align-items-center p-2 mt-2 bd-highlight">
            <Link to={"/home"}>
              <img src={logo1} className="img-nav" alt="..." />
            </Link>
          </div>
          <Link
            to={"/home"}
            className="align-items-center p-2 mt-2 bd-highlight HeaderIcons"
          >
            <p className="nav-text">AL-Asab </p>
          </Link>
        </div>

        <div className="headerMainRightContent bd-highlight">
          {props.data == true ? (
            <Link to={"/createimr"}>
              <button className="btn btn-primary imr-btn nav-imr-btn">
                Create NEW IMR
              </button>
            </Link>
          ) : props.data == false ? (
            <Link to={"/createisr"}>
              <button className="btn btn-primary imr-btn nav-imr-btn">
                Create NEW ISR
              </button>
            </Link>
          ) : null}
          {props?.data4?.length ? (
            <div
              onClick={() => openModal5()}
              className="p-2 bd-highlight HeaderIcons"
            >
              <Link to={""}>
                <img src={gridimg} alt="..." />
              </Link>
            </div>
          ) : (
            <Link className="p-2 bd-highlight HeaderIcons" to={"/home"}>
              <img src={gridimg} alt="..." />
            </Link>
          )}

          <div className="p-2  bd-highlight">
            <div onClick={handleNotification} className="p-2 bd-highlight">
              <div className="position-relative" onClick={handleNotification}>
                <img src={bellimg} alt="..." className="Notificationimg" />
                {/* {showDropdown2 && (
                  <div className="position-absolute  rounded shadow-lg bg-white border z-10">
                    <div className="py-1">
                      <div className="px-4 py-2 text-sm text-gray-700 d-flex align-items-center">

                        <p>Comming Soon</p>
                      </div>

                    </div>
                  </div>
                )} */}
              </div>
            </div>
          </div>
          <div className="p-2 bd-highlight questionimg">
            <img src={questionimg} alt="..." />
          </div>
          <div onClick={handleDropdownToggle} className="p-2 bd-highlight">
            <div className="position-relative dropdown">
              <img
                src={image ? image : profileimg}
                className="rounded-circle dropdown-toggle profileImg"
                alt="..."
                data-bs-toggle="dropdown"
                aria-expanded="false"
              />
              <ul className="dropdown-menu dropdown-menu-end">
                <li>
                  <div className="px-4 py-1 text-sm text-gray-700 d-flex align-items-center">
                    <img
                      src={image ? image : profileimg}
                      className=" me-2 profileImg"
                      alt="..."
                    />
                    <div>
                      <div className="profileName">
                        {firstName} {lastName}
                      </div>
                      <div className="ProfileEmail">{email}</div>
                    </div>
                  </div>
                </li>
                <li>
                  <hr className="dropdown-divider my-1 mx-3 " />
                </li>

                <li>
                  <div className="px-4 py-1 text-sm text-gray-700 d-flex align-items-center hover-bg-gray-100 cursor-pointer">
                    <Link
                      to={"/profile"}
                      className="profileDropDownContent changePasswordheader"
                    >
                      Profile
                    </Link>
                  </div>
                </li>
                <li>
                  <div className="px-4 py-1 text-sm text-gray-700 d-flex align-items-center hover-bg-gray-100 cursor-pointer">
                    <Link
                      to={"/change-password"}
                      className="profileDropDownContent changePasswordheader"
                    >
                      Change Password
                    </Link>
                  </div>
                </li>
                <li>
                  <hr className="dropdown-divider my-1 mx-3 d-block d-md-none d-lg-none" />
                </li>
                <li className="d-block d-md-none d-lg-none">
                  <div className="px-4 py-1 text-sm text-gray-700 d-flex align-items-center hover-bg-gray-100 cursor-pointer">
                    <div className="profileDropDownContent">Help</div>
                  </div>
                </li>
                <li>
                  <hr className="dropdown-divider my-1 mx-3 d-block d-md-none d-lg-none" />
                </li>
                <li>
                  <div
                    className="d-block d-md-none d-lg-none px-4 py-2 text-sm text-gray-700 d-flex align-items-center hover-bg-gray-100 cursor-pointer"
                    onClick={handleLogout}
                  >
                    <Link to={"/"} className="logout-link">
                      <div className="profileDropDownContent">Logout</div>
                    </Link>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <div className="p-2 bd-highlight HeaderIcons">
            <button onClick={() => openModal()} className="logout-button">
              <img src={logo2} className="img-logout" alt="..." />
              <Link className="logout-link ">Logout</Link>
            </button>
          </div>
        </div>
      </div>

      {modalIsOpen ? (
        <div className="deleteAccountMain">
          <Modal
            isOpen={modalIsOpen}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <div className="delModelHeader">
              <h2>Logout Confirmation</h2>
              <div class="horizontal-line"></div>
              <p>Are you sure you want to logout?</p>
              <div className="modal-button">
                <button
                  onClick={() => handleLogout()}
                  className="delAccountOkButton d-flex align-items-center justify-content-center"
                >
                  Logout
                </button>
                {/* <button
                  onClick={closeModal}
                  className="delAccountCancelButtonHeader d-flex align-items-center justify-content-center"
                >
                  cancel
                </button> */}
              </div>
            </div>
          </Modal>
        </div>
      ) : (
        ""
      )}

      {modalIsOpen5 ? (
        <div className="deleteAccountMain">
          <Modal
            isOpen={modalIsOpen5}
            onAfterOpen={afterOpenModal}
            onRequestClose={closeModal5}
            style={customStyles}
            contentLabel="Example Modal"
          >
            <div className="delModelHeader">
              <h2>Confirmation</h2>
              <div class="horizontal-line"></div>
              <p>
                Make sure to save your changes before leaving the page
                <br />
                to avoid losing any unsaved information.
              </p>
              <div className="modal-button">
                <button
                  onClick={() => history("/home")}
                  className="delAccountOkButton d-flex align-items-center justify-content-center"
                >
                  Yes, Leave Page
                </button>
                <button
                  onClick={closeModal5}
                  className="delAccountCancelButtonHeader d-flex align-items-center justify-content-center"
                >
                  No, Stay on Page
                </button>
              </div>
            </div>
          </Modal>
        </div>
      ) : (
        ""
      )}
    </div>
  );
};

export default Header;
